import { configureStore } from "@reduxjs/toolkit";
import { patientStorageMiddleware } from "./middleware/patientStorageMiddleware";
import adminPathSlice from "./slices/adminPathSlice";
import dashboardDataSlice from "./slices/dashboardDataSlice";
import patientLogInDataSlice from "./slices/patientLogInDataSlice";
import practiceReducer from "./slices/practiceSlice";
import referralOrderLoaderSlice from "./slices/referralOrderLoaderSlice";
import savedAiPatientDetailsSlice from "./slices/savedAiPatientDetailsSlice";
import selectedPatientReducer from "./slices/selectedPatientSlice";
import sideBarCollapseSlice from "./slices/sideBarCollapseSlice";
import snackBar from "./slices/snackBarSlice";
export default configureStore({
  reducer: {
    practiceSelector: practiceReducer,
    selectedPatientSelector: selectedPatientReducer,
    sideBarCollapseSelector: sideBarCollapseSlice,
    snackBarSelector: snackBar,
    dashboardDataSlice: dashboardDataSlice,
    patientLogInDataSelector: patientLogInDataSlice,
    adminPathSelector: adminPathSlice,
    savedAiPatientDetails: savedAiPatientDetailsSlice,
    referralOrderLoader: referralOrderLoaderSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(patientStorageMiddleware),
});
